import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth, formatApiErrorDetail } from '../context/AuthContext';
import { AuthShell, AuthDivider, GoogleButton, Field } from '../components/AuthShell';

const SignupPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', company_name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success('Workspace created — awaiting approval.');
      navigate('/admin');
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your workspace" subtitle="Start your white-label event photo portal. A platform admin approves new workspaces." testId="signup-card">
      <form onSubmit={handleSubmit} className="space-y-4">
        <Field label="Your name">
          <input data-testid="signup-name-input" className="input" value={form.name} onChange={update('name')} placeholder="Jane Doe" required />
        </Field>
        <Field label="Company / event brand">
          <input data-testid="signup-company-input" className="input" value={form.company_name} onChange={update('company_name')} placeholder="Acme Weddings" required />
        </Field>
        <Field label="Email">
          <input data-testid="signup-email-input" type="email" className="input" value={form.email} onChange={update('email')} placeholder="you@company.com" required />
        </Field>
        <Field label="Password">
          <input data-testid="signup-password-input" type="password" className="input" value={form.password} onChange={update('password')} placeholder="Create a password" required />
        </Field>
        <button data-testid="signup-submit-btn" type="submit" disabled={loading} className="btn-primary w-full">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          {loading ? 'Creating…' : 'Create workspace'}
        </button>
      </form>
      <AuthDivider />
      <GoogleButton />
      <p className="text-center text-sm text-slate-400">
        Already have an account?{' '}
        <Link to="/login" className="font-bold text-cyan hover:underline" data-testid="go-login-link">Sign in</Link>
      </p>
    </AuthShell>
  );
};

export default SignupPage;
